import { render, staticRenderFns } from "./TypographyDisplaySection.vue?vue&type=template&id=1e9473f9"
import script from "./TypographyDisplaySection.vue?vue&type=script&lang=ts"
export * from "./TypographyDisplaySection.vue?vue&type=script&lang=ts"
import style0 from "./TypographyDisplaySection.vue?vue&type=style&index=0&id=1e9473f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports